export default "__VITE_ASSET__Dm5EZDX8__"